import { Variants } from "framer-motion";
import { motionTokens } from "@/tokens/motion";

export const fadeUp: Variants = {
  hidden: { 
    opacity: 0, 
    y: motionTokens.distance.large,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { 
      duration: motionTokens.duration.slow, 
      ease: motionTokens.ease.default,
    },
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { 
      duration: motionTokens.duration.normal,
      ease: motionTokens.ease.default,
    },
  },
};

export const slideInFromLeft: Variants = {
  hidden: { 
    opacity: 0, 
    x: -motionTokens.distance.xlarge,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: { 
      duration: motionTokens.duration.slow,
      ease: motionTokens.ease.spring,
    },
  },
};

export const slideInFromRight: Variants = {
  hidden: { 
    opacity: 0, 
    x: motionTokens.distance.xlarge,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: { 
      duration: motionTokens.duration.slow,
      ease: motionTokens.ease.spring,
    },
  },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: motionTokens.stagger.normal,
    },
  },
};

export const staggerContainerFast: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: motionTokens.stagger.fast,
    },
  },
};

export const scaleHover = {
  whileHover: {
    scale: motionTokens.scale.medium,
    transition: { duration: motionTokens.duration.fast },
  },
  whileTap: {
    scale: 0.98,
    transition: { duration: motionTokens.duration.fast },
  },
};

export const cardHover = {
  whileHover: {
    y: -motionTokens.distance.small,
    boxShadow: "0px 20px 40px rgba(0,0,0,0.15)",
    transition: { duration: motionTokens.duration.fast },
  },
};

export const card3DHover = {
  whileHover: {
    y: -motionTokens.distance.small,
    rotateX: 5,
    rotateY: 5,
    scale: motionTokens.scale.subtle,
    boxShadow: "0px 25px 50px rgba(59, 164, 246, 0.15)",
    transition: { 
      duration: motionTokens.duration.normal,
      ease: motionTokens.ease.spring,
    },
  },
};

export const textReveal: Variants = {
  hidden: { 
    opacity: 0,
    y: motionTokens.distance.small,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { 
      duration: motionTokens.duration.normal,
      ease: motionTokens.ease.default,
    },
  },
};

export const shimmerText = {
  backgroundImage: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
  backgroundSize: "200% 100%",
  animation: "shimmer 2s infinite",
};

export const floatAnimation = {
  y: [0, -motionTokens.distance.small, 0],
  transition: {
    duration: motionTokens.duration.slower,
    repeat: Infinity,
    ease: motionTokens.ease.inOut,
  },
};

export const pulseGlow = {
  boxShadow: [
    "0px 0px 0px rgba(59, 164, 246, 0)",
    "0px 0px 20px rgba(59, 164, 246, 0.3)",
    "0px 0px 0px rgba(59, 164, 246, 0)",
  ],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: motionTokens.ease.inOut,
  },
};

export const numberCountUp = (from: number = 0, to: number, duration: number = 1) => ({
  initial: { value: from },
  animate: { 
    value: to,
    transition: { 
      duration: duration,
      ease: motionTokens.ease.out,
    },
  },
});

// Page transition variants
export const pageTransition: Variants = {
  initial: { 
    opacity: 0,
    y: motionTokens.distance.large,
  },
  in: { 
    opacity: 1,
    y: 0,
  },
  out: { 
    opacity: 0,
    y: -motionTokens.distance.large,
  },
};

export const pageTransitionSettings = {
  type: "tween",
  ease: motionTokens.ease.custom,
  duration: motionTokens.duration.slow,
};